import { FC } from 'react'
import { useIntl } from 'react-intl'

type Props = {}

const QueueEmptyMessage: FC<Props> = () => {
  const intl = useIntl()

  return (
    <div className="d-flex align-items-center justify-content-center py-8">
      {intl.formatMessage({ id: 'queue.empty_message' })}
    </div>
  )
}

export { QueueEmptyMessage }
